// extracted by mini-css-extract-plugin
module.exports = {"sourcesList":"ac","sourcePlate":"ad"};